window.Reverb = window.Reverb || {};

// Still used for message length limit in feedback response dialog (views/dashboard/feedback_response/_create.haml)
Reverb.DashboardFeedback = (function () {
  const messageErrorNotice = '.message-error-notice';

  function showMessageError(form) {
    form.find(messageErrorNotice).slideDown();
  }

  function hideMessageError(form) {
    form.find(messageErrorNotice).slideUp();
  }

  function textAreaLength($textArea) {
    const text = $textArea.val();
    const newLines = text.match(/(\r\n|\n|\r)/g);

    let additionalLength = 0;
    if (newLines != null) {
      additionalLength = newLines.length;
    }
    return text.length + additionalLength;
  }

  function bindMessageInput() {
    $('[data-max-message-length]').on('input', function () {
      const $this = $(this);
      const $form = $this.parents('form');
      const length = textAreaLength($this);
      if (length >= $this.prop('maxlength')) {
        showMessageError($form);
      } else {
        hideMessageError($form);
      }
    });
  }


  function init() {
    bindMessageInput();
  }

  return {
    init,
  };
}());

$(() => {
  Reverb.DashboardFeedback.init();
});
